/**
 * The demo's temp workers a task can be linked to: validated ones and others
 * still waiting for their check. The real ones come from POST
 * admin/crm/tempworkers.
 */
export const TASK_TEMP_WORKERS = [
  {
    id: 'tw1',
    firstname: 'Kévin',
    lastname: 'Rosemond',
    city: 'Le Lamentin',
    validated: true,
  },
  {
    id: 'tw2',
    firstname: 'Mélissa',
    lastname: 'Desroses',
    city: 'Schœlcher',
    validated: true,
  },
  {
    id: 'tw3',
    firstname: 'Steeve',
    lastname: 'Lordinot',
    city: 'Le Robert',
    validated: false,
  },
  {
    id: 'tw4',
    firstname: 'Laetitia',
    lastname: 'Bellemare',
    city: 'Ducos',
    validated: true,
  },
  {
    id: 'tw5',
    firstname: 'Dimitri',
    lastname: 'Sainte-Rose',
    city: 'Le François',
    validated: true,
  },
  {
    id: 'tw6',
    firstname: 'Cindy',
    lastname: 'Jean-Baptiste',
    city: 'Sainte-Marie',
    validated: false,
  },
  {
    id: 'tw7',
    firstname: 'Johan',
    lastname: 'Bellance',
    city: 'Fort-de-France',
    validated: true,
  },
  {
    id: 'tw8',
    firstname: 'Nadège',
    lastname: 'Pélage',
    city: 'Rivière-Salée',
    validated: true,
  },
  {
    id: 'tw9',
    firstname: 'Teddy',
    lastname: 'Marie-Sainte',
    city: 'Le Marin',
    validated: false,
  },
  {
    id: 'tw10',
    firstname: 'Sabrina',
    lastname: 'Joseph-Angélique',
    city: 'La Trinité',
    validated: true,
  },
  {
    id: 'tw11',
    firstname: 'Willy',
    lastname: 'Chéry',
    city: 'Saint-Joseph',
    validated: true,
  },
  {
    id: 'tw12',
    firstname: 'Stéphanie',
    lastname: 'Louis-Sidney',
    city: 'Basse-Pointe',
    validated: false,
  },
];

// The demo's stand-in for the api's search: a first name or a last name that
// starts with `search`, whatever the case, and nothing under 2 letters.
export const searchTaskTempWorkers = (search) => {
  const prefix = typeof search === 'string' ? search.trim().toLowerCase() : '';
  if (prefix.length < 2) return [];
  return TASK_TEMP_WORKERS.filter(
    (worker) =>
      worker.firstname.toLowerCase().startsWith(prefix) ||
      worker.lastname.toLowerCase().startsWith(prefix),
  );
};
